// FormFrame/fields/useDomEnforce.ts
import * as React from "react"

export function useEnforceInputValue(ref: React.RefObject<HTMLInputElement>, value: string) {
    React.useLayoutEffect(() => {
        const el = ref.current
        if (!el) return
        if (el.value !== value) el.value = value
    }, [ref, value])
}

export function useEnforceTextareaValue(ref: React.RefObject<HTMLTextAreaElement>, value: string) {
    React.useLayoutEffect(() => {
        const el = ref.current
        if (!el) return
        if (el.value !== value) el.value = value
    }, [ref, value])
}
